import htmx from "htmx.org";
import "htmx-ext-response-targets"
import { createBenchmateSocket } from "./htmx/ai-response-channel";

window.htmx = htmx;

// Signal Sprockets-side code (which loads in a separate bundle) that htmx is ready.
// activatePushedContent() in shared/bootstrap.js waits on this to avoid a load-order race.
document.dispatchEvent(new CustomEvent('htmx:appReady'));

htmx.config.historyCacheSize = 0;

htmx.defineExtension("ws-benchmate", {
  init: function (apiRef) {
    // Store reference to internal API
    const api = apiRef;
    // Default function for creating new EventSource objects
    htmx.createWebSocket = createBenchmateSocket;
  },
  transformResponse: function(text, xhr, elt) {
    // if text starts with a '<', assume it's HTML and return it
    // if more htmx extensions are added, this could be refactored into its own method to reuse.
    if (text.trim().charAt(0) === '<') {
      return text;
    }

    // otherwise, parse as JSON
    try {
      let data = JSON.parse(text);
      if (data.identifier && data.message) {
        return JSON.stringify(data.message.html);
      }
      return text;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("failed to parse JSON in transformResponse:", err);
      return text;
    }
  }
});
